import { render, staticRenderFns } from "./CIconTeaser.vue?vue&type=template&id=1a26257f&"
import script from "./CIconTeaser.vue?vue&type=script&lang=js&"
export * from "./CIconTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports